import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { Button } from "@/components/ui/button";

export function MarketingLayout({ children }) {
  const loc = useLocation();
  const navItem = (to, label) => (
    <Link
      to={to}
      data-testid={`nav-link-${label.toLowerCase().replace(/\s+/g, "-")}`}
      className={`text-sm font-medium transition-colors ${
        loc.pathname === to ? "text-[#1F3A6B]" : "text-slate-600 hover:text-[#1F3A6B]"
      }`}
    >
      {label}
    </Link>
  );

  return (
    <div className="min-h-screen flex flex-col bg-white">
      <header className="sticky top-0 z-30 bg-white/80 backdrop-blur border-b border-slate-100">
        <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
          <Link to="/" data-testid="header-home-link"><Logo size={30} /></Link>
          <nav className="hidden md:flex items-center gap-7">
            {navItem("/", "Home")}
            {navItem("/what-is-nps", "What is NPS")}
            {navItem("/calculator", "NPS Calculator")}
            {navItem("/templates", "Templates")}
            {navItem("/pricing", "Pricing")}
            {navItem("/blog", "Blog")}
          </nav>
          <div className="flex items-center gap-2">
            <Link to="/login"><Button variant="ghost" data-testid="header-login-btn" className="text-[#1F3A6B] hover:text-[#1F3A6B] hover:bg-slate-50">Sign in</Button></Link>
            <Link to="/signup"><Button data-testid="header-signup-btn" className="bg-[#F58220] hover:bg-[#E36F0E] text-white">Start free</Button></Link>
          </div>
        </div>
      </header>
      <main className="flex-1">{children}</main>
      <footer className="border-t border-slate-100 bg-slate-50/50">
        <div className="max-w-7xl mx-auto px-6 py-12 grid md:grid-cols-4 gap-8">
          <div>
            <Logo size={28} />
            <p className="mt-3 text-sm text-slate-600 max-w-xs">AI-first NPS & Customer Experience intelligence. Built for global, self-serve teams.</p>
          </div>
          <div>
            <p className="text-xs uppercase tracking-wider text-slate-500 font-semibold">Product</p>
            <ul className="mt-3 space-y-2 text-sm">
              <li><Link to="/templates" className="text-slate-700 hover:text-[#1F3A6B]">Templates</Link></li>
              <li><Link to="/calculator" className="text-slate-700 hover:text-[#1F3A6B]">NPS Calculator</Link></li>
              <li><Link to="/pricing" className="text-slate-700 hover:text-[#1F3A6B]">Pricing</Link></li>
            </ul>
          </div>
          <div>
            <p className="text-xs uppercase tracking-wider text-slate-500 font-semibold">Resources</p>
            <ul className="mt-3 space-y-2 text-sm">
              <li><Link to="/what-is-nps" className="text-slate-700 hover:text-[#1F3A6B]">What is NPS</Link></li>
              <li><Link to="/blog" className="text-slate-700 hover:text-[#1F3A6B]">Blog</Link></li>
            </ul>
          </div>
          <div>
            <p className="text-xs uppercase tracking-wider text-slate-500 font-semibold">Company</p>
            <ul className="mt-3 space-y-2 text-sm">
              <li><Link to="/signup" className="text-slate-700 hover:text-[#1F3A6B]">Get started</Link></li>
              <li><Link to="/login" className="text-slate-700 hover:text-[#1F3A6B]">Sign in</Link></li>
            </ul>
          </div>
        </div>
        <div className="border-t border-slate-100 py-5 text-center text-xs text-slate-500">
          © {new Date().getFullYear()} CX10X — All rights reserved.
        </div>
      </footer>
    </div>
  );
}
